import { cloneDeep } from 'lodash';

export const tablePageSizeOptions = [25, 50, 100];
export const tablePageSizeForPreview = 10;

const paramKeysMapping: { [key in keyof ServerTableParamsType]: { key: key, queryKey: string, defaultValue: any } } = {
    itemsPerPage: { key: 'itemsPerPage', queryKey: 'page_size', defaultValue: tablePageSizeOptions[0] },
    page: { key: 'page', queryKey: 'page', defaultValue: 1 },
    sortBy: { key: 'sortBy', queryKey: 'sort', defaultValue: [{ key: 'id', order: 'desc' }] },
    search: { key: 'search', queryKey: 'search', defaultValue: "" },
    filter: { key: 'filter', queryKey: 'filter', defaultValue: {} },
};

interface SortByType {
    key: string,
    order: "asc" | "desc",
};

export interface DynamicItemsService {
    getAll(params: any): Promise<any>;
    get: (id: number) => Promise<any>,
    defaultTableParams?: ServerTableParamsType,
}

export type ServerTableParamsType = {
    page: number,
    itemsPerPage: number,
    sortBy: SortByType[],
    search: string,
    filter: Record<string, string | number | boolean>,
};

export const DefaultServerTableParams: ServerTableParamsType = Object.keys(paramKeysMapping).reduce((acc, key) => {
    const paramKey = key as keyof ServerTableParamsType;
    (acc as any)[paramKey] = paramKeysMapping[paramKey].defaultValue;
    return acc;
}, {} as ServerTableParamsType);


export function getServerTableQuery(stParams?: ServerTableParamsType) {
    if (!stParams || !Object.keys(stParams).length) return {};

    const queryParams: Record<string, any> = {};

    for (const key in paramKeysMapping) {
        const paramKey = key as keyof ServerTableParamsType;
        const queryKey = paramKeysMapping[paramKey].queryKey;
        const value = stParams[paramKey];
        if (value !== undefined && value !== null && value !== "" && !(typeof value === 'object' && Object.keys(value).length === 0 && value.constructor === Object)) {
            if (paramKey === 'sortBy') {
                queryParams[queryKey] = stParams.sortBy.map(x => (x.order === "desc" ? "-" : "") + x.key).join(",");
            } else if (paramKey === 'filter') {
                queryParams[queryKey] = generateFilterParameter(value as Record<string, string>);
            } else {
                queryParams[queryKey] = value;
            }
        }
    }

    return queryParams;
}

export function updateTableParams(commonParams: ServerTableParamsType, newParams?: Partial<ServerTableParamsType>): ServerTableParamsType {
    if (!newParams) return commonParams;
    let updatedParams: Partial<ServerTableParamsType> = cloneDeep(commonParams);

    for (const key in paramKeysMapping) {
        const newValue = newParams[key as keyof ServerTableParamsType];
        if (newValue !== undefined && newValue !== null) {
            if (Array.isArray(newValue)) {
                updatedParams[key as keyof ServerTableParamsType] = newValue as any;
            } else if (typeof newValue === 'object' && !(newValue instanceof Date)) {
                if (Object.keys(newValue).length > 0) {
                    updatedParams[key as keyof ServerTableParamsType] = newValue as any;
                }
            } else {
                updatedParams[key as keyof ServerTableParamsType] = newValue as any;
            }
        }
    }

    return {
        ...DefaultServerTableParams,
        ...updatedParams,
    };
}

function generateFilterParameter(filterDict: Record<string, number | string>) {
    return Object.entries(filterDict)
        .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
        .join(',');
}